import { ReactNode } from 'react';

import GreenScoreIcon from '../GreenScoreIcon';
import { devhubMakeStyles } from '@devxdiscover/devhub-ui/dist/style/devhubMakeStyles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';

interface GreenScoreModalContainerProps {
  children: ReactNode;
  heading: ReactNode;
}

/**
 * GreenScoreModalContainer
 * @param props Renders children
 * @returns Component
 */
function GreenScoreModalContainer(props: GreenScoreModalContainerProps) {
  const classes: ClassNameMap<string> = devhubMakeStyles({
    iconContainer: {
      width: '75px',
      height: '75px',
      backgroundColor: 'white',
      borderRadius: '50px',
      marginRight: '10px',
    },
    modalContainer: {
      position: 'relative',
      padding: 0,
      margin: 0,
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
    },
  })();

  return (
    <div className={classes.modalContainer}>
      <div className={classes.titleContainer}>
        <div className={classes.iconContainer}>
          <GreenScoreIcon />
        </div>
        {props.heading}
      </div>
      {props.children}
    </div>
  );
}

export default GreenScoreModalContainer;
